export default class SubCategoryDesc {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        subCategoryDescRetrieve(id: ${id}) {
          id
          name
          desc
          logo {
            id 
            url
          }          
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.subCategoryDescRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        subCategoryDescList(pageSize:10000000) {
          results {
            id
            name
            desc
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.subCategoryDescList.results.reverse();
  }

  // static async filter(axios, region) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       cityList (region: ${region}){
  //         results {
  //           id
  //           name
  //           latitude
  //           longitude
  //           region {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //   return response.data.data.cityList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteSubCategoryDesc(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteSubCategoryDesc.ok;
  }

  static async create(axios, name, desc, logo) {
    const description = desc !== null ? `,desc: "${desc}"`: ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createSubCategoryDesc(newSubcategorydesc: {
          ${logoField}
          name: "${name}" 
          ${description}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createSubCategoryDesc.ok;
  }


  static async edit(axios, id, name, desc, logo) {
    const description = desc !== null ? `,desc: "${desc}"`: ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateSubCategoryDesc(newSubcategorydesc: {
          ${logoField}
          id: ${id},
          name: "${name}"
          ${description}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateSubCategoryDesc.ok;
  }

}
